import React, {Fragment} from 'react';
import Item from './Item';
import { makeStyles } from '@material-ui/core/styles';

// created_at: "2020-07-11 18:56:03"
// description: "aqui se vende papelon"
// fantasy_name: "Tio Papelón"
// id: 2
// id_company: 5012
// id_row: 1
// image_1: "images/660fc3dcbb4869e8ab2ecf024d322564.jpeg"
// image_2: "images/6a6c1b3730b2f934c38e1f7d0a836f36.jpeg"
// is_enabled: 1
// order: 0
// title: "Tio papelon"
// updated_at: "2020-07-11 23:23:49"
// url: "https://tiopapelon.max.delivery/"
// url_prefix: "http://localhost:8000"
// width: "4"

const ItemsContent = ({items, storeBoxColor, setItems}) => {

  const reOrderItems = () => {
    console.log("okddkowkdkd");
  };


  return (
    <div className="container asp-container">

      {
        items.map((item, index) => (
          item.item_type==="companies" ?
            item.board.columns.length>0 ?
              <Fragment key={index}>
                <div className="row asp-item">
                  <div className="col-lg-12 col-md-12 col-lg-12 p-2">
                    <h3 className={"text-"+item.textalign} style={{ color: item.titlecolor }}>{ item.title }</h3>
                    {
                      item.subtitle!=="" ?
                      <h5 className={"text-"+item.textalign} style={{ color: item.subtitlecolor }}>{ item.subtitle }</h5>
                      :
                      null
                    }
                  </div>
                </div>
                <div className="row asp-item  mb-4">
                {
                  item.board.columns.map((column, indexC) => (
                    <Item
                      url={column.cards[0].url}
                      col={column.cards[0].width}
                      name={column.cards[0].title}
                      description={column.cards[0].description}
                      open={column.cards[0].open}
                      open_text={column.cards[0].open_text}
                      consider_color={column.cards[0].consider_color}
                      image={column.cards[0].url_prefix+'/'+column.cards[0].image_1}
                      image_2={column.cards[0].url_prefix+'/'+column.cards[0].image_2}
                      key={indexC}
                      storeBoxColor={storeBoxColor}
                    />
                  ))
                }
                </div>
              </Fragment>
            :
              null
          :

            item.board.columns.length>0 ?
              <Fragment key={index}>
                <div className="row asp-item">
                  <div className="col-lg-12 col-md-12 col-lg-12 p-2 mb-4">
                    <h3 className={"text-left"} style={{ color: "#000" }}>{ item.title }</h3>
                  </div>
                </div>
                <div className="row asp-item">
                {
                  item.board.columns.map((column, indexC) => (
                    <Item
                      url={column.cards[0].url}
                      col={"4"}
                      name={column.cards[0].name_es}
                      description={column.cards[0].short_description}
                      image={column.cards[0].url_image}
                      key={indexC}
                      subtitle={column.cards[0].fantasy_name}
                      url_store={column.cards[0].url_store}
                      open={column.cards[0].open}
                      open_text={column.cards[0].open_text}
                      consider_color={column.cards[0].consider_color}
                      price={column.cards[0].price.toLocaleString('es-ES') + " €"}
                      storeBoxColor={storeBoxColor}
                    />
                  ))
                }
                </div>
              </Fragment>
            :
              <Fragment key={index}>
                <div className="descrptest" dangerouslySetInnerHTML={{__html: '<h5>No se han encontrado productos que coincidan</h5>'}} />
              </Fragment>

        ))
      }
    </div>
  );
}

export default ItemsContent;
